module.exports = __webpack_public_path__ + "img/talron-menu-help.12513f0d.svg";